import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { retry, timer } from 'rxjs';

const RETRY_CONFIG = {
  maxAttempts: 3,
  scalingDuration: 1000,
  retryOnStatus: [503],
};

export const retryInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== 'GET') {
    return next(req);
  }

  return next(req).pipe(
    retry({
      count: RETRY_CONFIG.maxAttempts,
      delay: (error: HttpErrorResponse, attempt) => {
        if (!RETRY_CONFIG.retryOnStatus.includes(error.status)) {
          throw error;
        }

        return timer(
          RETRY_CONFIG.scalingDuration * Math.pow(2, attempt - 1)
        );
      },
    })
  );
};
